export { default as StickerPreview } from './StickerPreview/StickerPreview.svelte';
export { default as LiveLineItemStickerPreview } from './StickerPreview/LiveLineItemStickerPreview.svelte';
export { default as ColorEffectsSelector } from './ColorEffectsSelector/ColorEffectsSelector.svelte';
export { default as generateMasks } from './StickerPreview/PreviewTools/mask-generator';
export * as SVGUtils from './svg-utils';
export * as MaskUtils from './mask-utils';

export type {
  Sticker,
  StickerPreviewProps,
  PreviewBaseProps,
  WhiteLayerMask,
  Material,
  Laminate,
  PreviewSettings,
  ProductItemDimensions,
} from './types';

export type {
  ColorEffectSelectorTranslations,
  TranslatedMaterialName,
} from './ColorEffectsSelector/types';

export type { SvgPreviewProps } from '../SvgPreview/types';

/* Enum export */
export {
  LaminateType,
  WhiteLayerMaskMode,
  MaterialName,
  StickerPreviewAnimationMode,
  MaskSource,
} from './types';

import { LaminateType, MaterialName, type Laminate, type Material } from './types';

/* Add more "feature" flags for material and laminate options? */
export const materialOptions: Material[] = [
  {
    type: MaterialName.Vinyl,
    enabled: true,
    title: 'Vinyl',
    isMetal: false,
    laminateSettings: { enabled: true, laminateOpacity: 0.05 },
  },
  {
    type: MaterialName.Holographic,
    enabled: true,
    title: 'Holografisk',
    isMetal: true,
    metallicOpacity: 0.03,
    laminateSettings: { enabled: true, laminateOpacity: 0.05 },
  },
  {
    type: MaterialName.Prismatic,
    enabled: true,
    title: 'Prismatisk',
    isMetal: true,
    metallicOpacity: 0.03,
    laminateSettings: { enabled: true, laminateOpacity: 0.05 },
  },
  {
    type: MaterialName.Glitter,
    enabled: true,
    title: 'Glitter',
    isMetal: true,
    metallicOpacity: 0.03,
    laminateSettings: { enabled: true, laminateOpacity: 0.05 },
  },
  {
    type: MaterialName.Recycled,
    enabled: true,
    title: 'Återvunnet',
    isMetal: false,
    laminateSettings: { enabled: true, laminateOpacity: 0.05 },
  },
  {
    type: MaterialName.Pixie,
    enabled: true,
    title: 'Pixie Dust',
    isMetal: true,
    metallicOpacity: 0.03,
    laminateSettings: { enabled: true, laminateOpacity: 0.05 },
  },
  {
    type: MaterialName.Brushed,
    enabled: true,
    title: 'Aluminium',
    isMetal: true,
    metallicOpacity: (laminateName) => (laminateName == LaminateType.Glossy ? 0.15 : 0.3),
    laminateSettings: { enabled: true, laminateOpacity: 0.05 },
  },
  {
    type: MaterialName.Mirror,
    enabled: true,
    title: 'Spegel',
    isMetal: true,
    metallicOpacity: 0.3,
    laminateSettings: { enabled: true, laminateOpacity: 0.05 },
  },
  {
    type: MaterialName.Clear,
    enabled: true,
    title: 'Transparent',
    isMetal: false,
    laminateSettings: { enabled: true, laminateOpacity: 0.05 },
  },
  {
    type: MaterialName.WhiteHiTack,
    enabled: true,
    title: 'Hi-Tack vinyl',
    isMetal: false,
    laminateSettings: { enabled: true, laminateOpacity: 0.05 },
  },
  {
    type: MaterialName.Gitd,
    enabled: true,
    title: 'Glow in the dark',
    isMetal: false,
    laminateSettings: { enabled: true, laminateOpacity: 0.05 },
  },
  {
    type: MaterialName.Reflective,
    enabled: true,
    title: 'Reflective',
    isMetal: false,
    laminateSettings: { enabled: true, laminateOpacity: 0.05 },
  },
  {
    type: MaterialName.WhiteRemovable,
    enabled: true,
    title: 'Removable Vinyl',
    isMetal: false,
    laminateSettings: { enabled: true, laminateOpacity: 0.05 },
  },
  {
    type: MaterialName.WhiteSturdy,
    enabled: true,
    title: 'White and Sturdy',
    isMetal: false,
    laminateSettings: { enabled: true, laminateOpacity: 0.05 },
  },
  {
    type: MaterialName.WhiteThin,
    enabled: true,
    title: 'White Thin',
    isMetal: false,
    laminateSettings: { enabled: true, laminateOpacity: 0.05 },
  },
  {
    type: MaterialName.ClearThin,
    enabled: true,
    title: 'Thin transparent',
    isMetal: false,
    laminateSettings: { enabled: true, laminateOpacity: 0.05 },
  },
  {
    type: MaterialName.KraftThin,
    enabled: true,
    title: 'Thin recycled',
    isMetal: false,
    laminateSettings: { enabled: true, laminateOpacity: 0.05 },
  },
  {
    type: MaterialName.SilverThin,
    enabled: true,
    title: 'silver_thin',
    isMetal: true,
    metallicOpacity: 0.3,
    laminateSettings: { enabled: true, laminateOpacity: 0.05 },
  },
  {
    type: MaterialName.WhiteWall,
    enabled: true,
    title: 'white_wall',
    isMetal: false,
    laminateSettings: { enabled: true, laminateOpacity: 0.05 },
  },
  {
    type: MaterialName.SatinMatte,
    enabled: true,
    title: 'satin_matte',
    isMetal: false,
    laminateSettings: { enabled: true, laminateOpacity: 0.05 },
  },
];

export const laminateOptions: Laminate[] = [
  LaminateType.Glossy,
  LaminateType.Matte,
  LaminateType.Cracked,
  LaminateType.GlossyThin,
  LaminateType.GlossyThinNoUV,
];
export const STICKER_PREVIEW_CONTEXT_KEY = 'stickerPreviewContext';

export type StickerPreviewContext = {
  STICKERAPP_API_URL: string;
  ATLAS_ASSET_BASE_URL: string;
};
